<template>
<div class="page page_hezuo">
    <!-- v-if 判断一下是哪一个角色 -->
    <!-- 匠人 -->
    <div v-if="type==1" class="bg tradesman">生命因传承而精彩</div>
    <!-- 合伙人-->
    <div v-if="type==4" class="bg">欢迎加入时代记忆城市合伙人大家庭</div>
    <!-- 供应商 -->
    <div v-if="type==2" class="bg">欢迎加入时代记忆供应商大家庭</div>
    <!-- 代理商 -->
    <div v-if="type==3" class="bg">欢迎加入时代记忆代理商大家庭</div>
    <div class="step">
        <!-- 进行状态 加active类 ; 非进行状态 不加-->
        <div class="step_item active">
            <div class="step_name">填写信息</div>
            <div class="step_icon active">
                <div class="icon"></div>
            </div>
        </div>
        <div class="step_item active">
            <div class="step_name">审核</div>
            <div :class="status!=0 ? 'step_icon active':'step_icon'">
                <div class="icon"></div>
            </div>
        </div>
        <div :class="status!=0 ? 'step_item active': 'step_item'">
            <div class="step_name">{{status==2?'审核失败' :'成功入驻'}}</div>
            <div class="step_icon">
                <div class="icon"></div>
            </div>
        </div>
    </div>
    <!-- 审核中 -->
    <div class="status" v-if="status == 0">
        <div class="tu">
            <img :src="publicPath+'statics/images/jiangren/applying.png'" alt="" class="">
        </div>
        <div class="status_tip">已提交，系统审核中<br />请您耐心等待</div>
    </div>
    <!-- 审核失败 -->
    <div class="status" v-if="status == 2">
        <div class="tu">
            <img :src="publicPath+'statics/images/jiangren/applyfailed.png'" alt="" class="">
        </div>
        <div class="status_tip">审核失败<br />请联系客服，客服电话16601367749</div>
        <div class="big_btn bottom" @click="reSubmit">重新提交</div>
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import Field from 'vant';
import {
    Uploader
} from 'vant';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    data() {
        return {
            publicPath: process.env.BASE_URL,
            type: 1,// 1匠人 2供应商 3代理商 4城市合伙人
            status: 0 // 审核状态 0审核中 1审核成功 2审核失败
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //设置导航栏
            var params = {
                'data': {
                    'naviTitle': '审核状态'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
        }
	},
	mounted: function(){
		// 四个合作角色审核状态, 申请失败可重新提交资料, 下面的状态用于回退
		this.type = this.$route.query.type
		// console.log('tradesman_apply_status',localStorage.getItem('tradesman_apply_status'))
		if(this.type == 1 && localStorage.getItem('tradesman_apply_status') != null){
			this.status = localStorage.getItem('tradesman_apply_status')
		}
		else if(this.type == 2 && localStorage.getItem('seller_apply_status') != null){
			this.status = localStorage.getItem('seller_apply_status')
		}
		else if(this.type == 3 && localStorage.getItem('agent_apply_status') != null){
			this.status = localStorage.getItem('agent_apply_status')
		}
		else if(this.type == 4 && localStorage.getItem('partner_apply_status') != null){
			this.status = localStorage.getItem('spartner_apply_status')
		}
		else{
			this.status =  this.$route.query.status
		}
		
		// console.log('状态',localStorage.getItem('seller_apply_status'))
		// console.log('status',this.status)
	},
    methods: {
        reSubmit(){
            var path = ''
            switch (parseInt(this.type) ) {
                case 1:
                    path = '/cooperation/tradesman'
                    break
                case 2:
                    path = '/cooperation/seller'
                    break
                case 3:
                    path = '/cooperation/agent'
                    break
                case 4:
                    path = '/cooperation/partner'
                    break
            }
            // 1匠人 2供应商 3代理商 4城市合伙人
            this.$router.push({
				path: path,
				query: {
					status: 1 // 1 修改
				}
            })
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.page .upload-images {
    margin-top: .4rem;
}
</style>
